import { Pipe, PipeTransform } from '@angular/core';
import { parseToDate } from '../../helpers';
import dayjs from 'dayjs';

@Pipe({
  name: 'relativeTime',
  standalone: true
})
export class UmssRelativeTimePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) return 'N/A';
    const rtf = new Intl.RelativeTimeFormat('en', {
      localeMatcher: 'best fit',
      numeric: 'always',
      style: 'long'
    });

    let date: Date;

    if (typeof value === 'string') {
      date = parseToDate(value);
    } else {
      date = value;
    }

    if (!dayjs(date).isValid()) return 'N/A';

    const now = dayjs();
    const target = dayjs(date);

    const unitToUse = this.getUnitToUse(now, target);
    if (!unitToUse) return 'N/A';

    return rtf.format(
      -1 * now.diff(target, unitToUse as dayjs.ManipulateType),
      unitToUse as Intl.RelativeTimeFormatUnit
    );
  }

  private getUnitToUse(
    now: dayjs.Dayjs,
    target: dayjs.Dayjs
  ): string | undefined {
    const units: string[] = [
      'year',
      'month',
      'week',
      'day',
      'hour',
      'minute',
      'second'
    ];

    let unitToUse: string | undefined = undefined;

    const analizeFuture = now.isBefore(target);

    for (const unit of units) {
      const diff = now.diff(target, unit as dayjs.ManipulateType);
      if (analizeFuture) {
        if (-diff >= 1) {
          unitToUse = unit;
          break;
        }
        continue;
      }

      if (diff >= 1) {
        unitToUse = unit;
        break;
      }
    }

    return unitToUse;
  }
}
